// engine-console.ts — X11 drop 1 / X10's first step (owner, 2026-10-05): the ENGINE console's sign-in. The engine's own
// operator key — separate from the TubeForge sign-in — is entered once per browser session (sessionStorage: gone when the
// tab closes; never sent to TubeForge's servers as anything but the header the engine checks). Every covers read goes
// through the backend's proxy WITH it; without it the proxy refuses ("sign in to the engine console first").
import { apiRequest } from "./client.ts";

const KEY = "tf.engineOperatorKey";
export const engineOperatorKey = (): string | null => { try { return sessionStorage.getItem(KEY); } catch { return null; } };  // catch-reason: browser storage off or blocked: nothing remembered
export const setEngineOperatorKey = (k: string) => { try { sessionStorage.setItem(KEY, k.trim()); } catch { /* storage off */ } };
export const clearEngineOperatorKey = () => { try { sessionStorage.removeItem(KEY); } catch { /* storage off */ } };

export class EngineSignInRequired extends Error { constructor() { super("Sign in to the engine console first."); this.name = "EngineSignInRequired"; } }

export { looksLikeOperatorKey } from "./engine-console-rules.ts";

/** A covers call to the engine (drop 1: the reads; drop 2a: the state writes), through `/api/admin/engine/*` with the
 *  operator's key. A refused key is forgotten, and the page asks again. */
async function engineCall<T>(method: "GET" | "POST" | "DELETE", path: string, body?: unknown): Promise<T> {
  const key = engineOperatorKey();
  if (!key) throw new EngineSignInRequired();
  try {
    return await apiRequest<T>(`/admin/engine${path}`, { method, headers: { "x-engine-operator": key }, ...(body === undefined ? {} : { body }) });
  } catch (e) {
    // (audit A9) the proxy answers a missing / refused engine key 403 engine_sign_in_required (never 401: a 401 signs the
    //  user out of TubeForge) — the key is forgotten and the page asks again
    if (/engine_sign_in_required/i.test(String((e as Error)?.message ?? ""))) { clearEngineOperatorKey(); throw new EngineSignInRequired(); }
    throw e;
  }
}
export const engineGet = <T>(path: string) => engineCall<T>("GET", path);
export const enginePost = <T>(path: string, body: unknown = {}) => engineCall<T>("POST", path, body);
export const engineDelete = <T>(path: string) => engineCall<T>("DELETE", path);
